import React from "react";
import Link from "next/link";

const CaseworkerReferralHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Caseworker Patient Referral</h2>
            <p>
                As a healthcare professional, we're here to help with your patient
                referrals:
            </p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Schedule a Meeting</h3>
                    <p className="text-gray-800 mt-1">
                        <Link
                            href="https://meetings.hubspot.com/community49"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            Book a time
                        </Link>{" "}
                        to discuss your patient's needs with our senior living advisors.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Contact Us</h3>
                    <p className="text-gray-800 mt-1">
                        Visit our{" "}
                        <Link
                            href="/contact-us"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            contact page
                        </Link>{" "}
                        to submit a patient referral or learn more about our process.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Call Us</h3>
                    <p className="text-gray-800 mt-1">
                        Reach us at{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) PURPLE-3
                        </a>{" "}
                        or{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) 787-7533
                        </a>
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">What to Expect</h3>
                    <ul className="list-disc pl-5 mt-2 text-gray-800 space-y-1">
                        <li>Quick response within 24 hours</li>
                        <li>Personalized assistance</li>
                        <li>Support throughout the process</li>
                    </ul>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                Our team is available during business hours to assist with your referrals.
            </p>
        </div>
    );
};

export default CaseworkerReferralHelp;
